module.exports = __webpack_public_path__ + "assets/img/hero-title-0185ae14.png";